<template>
	<div class="wrapper">
		<slot />
	</div>
</template>

<style scoped>
.wrapper {
	width: 100%;
	max-width: 1040px;
	margin: 0 auto;
	background-color: #fff;
	padding: 75px 50px 80px;
	display: flex;
}

@media (max-width: 1080px) {
	.wrapper {
		flex-direction: column;
		text-align: center;
	}
}

@media (max-width: 500px) {
	.wrapper {
		padding: 50px;
	}
}
</style>
